<template>
  <v-layout>
    <v-flex>

      <products-data-table :headers="[{text: $t('prodotti.label.sku'), value: 'sku', width: 20},
                                    {text: $t('prodotti.label.nome'), value: 'name', sortable: true, width: 40},
                                    {text: $t('prodotti.label.prezzo_assegnato'), value: 'price_costumer', sortable: true, width: 15, right: true},
                                    {text: $t('prodotti.label.quantita_magazzino'), value: 'quantita', sortable: true, width: 10, right: true, info: $t('prodotti.label.quantita_magazzino_info')},
                                    {text: $t('prodotti.label.quantita_esterna'), value: 'quantitaEsterna', sortable: true, width: 10, right: true, info: $t('prodotti.label.quantita_esterna_info')},
                                    {text: '', value: 'removable', width: 5, right: true}]"
                           :prodotti="prodotti" :loading="loading" show-filters show-dismessi
                           :product-dialog-props="{showEditQuantitaMagazzino: true, showRipristina: true}"
                           :title="$t('header.magazzino')"
                           :category.sync="category"
                           @click:remove="showRemoveProdottoConfirmDialog"
                           @re-enabled="fetchDismessi"
                           @quantita-changed="fetchAttivi"
                           :rows-per-page="11"/>

      <v-btn v-if="!$store.getters.isAbbonamentoExpired" color="accent" @click="showShopDialog"
             fixed right bottom round large>
        <v-icon class="mr-2">add</v-icon>
        {{ $t('azioni.aggiungi') }}
      </v-btn>

      <shop-dialog ref="shopDialog" @success="onShopSuccess"/>

    </v-flex>
  </v-layout>
</template>
<script>
import ProductsDataTable from '@/components/ProductsDataTable'
import ShopDialog from '@/components/ShopDialog'

export default {
    name: 'MagazzinoView',
    components: { ShopDialog, ProductsDataTable },
    data: () => ({
        prodotti: [],
        loading: false,
        category: null
    }),
    created () {
        this.fetchAttivi()
    },
    watch: {
        category (newVal, oldVal) {
            if (newVal === -1) {
                this.fetchDismessi()
            } else if (oldVal === -1) {
                this.fetchAttivi()
            }
        }
    },
    methods: {
        showShopDialog () {
            this.$refs.shopDialog.show()
        },
        showRemoveProdottoConfirmDialog (prodotto) {
            this.$confirmDialog.show(prodotto, this.$t('magazzino.messaggi.conferma_rimozione_prodotto'), this.removeProdotto)
        },
        removeProdotto (prodotto) {
            this.$api.magazzino.dismettiFromLocal(prodotto).then(async response => {
                this.$snackbar.show(this.$t('magazzino.messaggi.prodotto_rimosso'), 'success')
                this.fetchAttivi()
                await this.$store.dispatch('loadProdottiDismessi', true)
            }).catch(e => {
                if (e.response && e.response.data.message === 'in use') {
                    this.$snackbar.show(this.$t('magazzino.errori.prodotto_in_use'), 'error')
                } else {
                    this.$snackbar.showServerError(e)
                }
            })
        },
        onShopSuccess () {
            this.category = null
            this.fetchAttivi()
        },
        fetchAttivi () {
            this.prodotti = []
            this.loading = true
            this.$api.magazzino.getInternalAll().then(response => {
                this.prodotti = response.data
                this.loading = false
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        },
        fetchDismessi () {
            this.prodotti = []
            this.loading = true
            this.$store.dispatch('loadProdottiDismessi', true).then(response => {
                this.prodotti = this.$store.state.global.prodottiDismessi
                this.loading = false
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        }
    }

}
</script>
